import React from 'react';
import { motion } from 'framer-motion';
import { ParallaxSection } from './ParallaxSection';
const CTA_BG = 'https://cdn.magicpatterns.com/uploads/gSWTzHhYW4DyyfK4mQXJZD/hal-gatewood-hfP4PkRN0mw-unsplash.jpg';
export function FinalCTA() {
  return <ParallaxSection bgImage={CTA_BG} overlayOpacity={0} className="py-24 md:py-32 relative" data-id="element-32">
      <div className="absolute inset-0 bg-brand-black/80 z-0" data-id="element-33" />
      <div className="absolute inset-0 backdrop-grayscale z-0" data-id="element-34" />
      <div className="absolute inset-0 film-grain z-0" data-id="element-35" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10" data-id="element-36">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-brand-soft text-[44px] md:text-[80px] leading-[0.9] font-display mb-6 uppercase" data-id="element-37">
          Your <span className="text-brand-lime" data-id="element-38">Free</span> Device
          <br data-id="element-39" />
          Is Waiting.
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-brand-soft/80 text-lg md:text-xl mb-10 font-sans" data-id="element-40">
          Find out in 60 seconds if you qualify. No commitment, no credit check.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="flex flex-col sm:flex-row justify-center gap-4 w-full sm:w-auto" data-id="element-41">
          <button className="w-full sm:w-auto bg-brand-lime text-brand-black px-8 py-4 font-mono font-bold text-sm uppercase tracking-widest hover:bg-white transition-colors min-h-[52px]" data-id="element-42">
            Check Eligibility
          </button>
          <button className="w-full sm:w-auto bg-transparent border-2 border-brand-concrete text-brand-soft px-8 py-4 font-mono font-bold text-sm uppercase tracking-widest hover:border-brand-lime hover:text-brand-lime transition-colors min-h-[52px]" data-id="element-43">
            Schedule Appointment
          </button>
        </motion.div>
      </div>
    </ParallaxSection>;
}